<template>
  <div id="app">
    <header>
      <div id="nav">
        <b-navbar toggleable="lg" type="light" variant="mdh" class="flex-column align-items-baseline pt-3 pl-4 pr-4">
          <div class="nav-heading">
            <b-navbar-brand>
              <img src="./assets/logo-reverse.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
            </b-navbar-brand>
            <h1 class="app-name">
              VaxCheck Program
            </h1>
          </div>

          <div v-if="authenticated">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav align="center">
                  <b-nav-item href="/home">Home</b-nav-item>
                  <b-nav-item href="/consent" v-if="authenticated && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin') || hasRole('org-user'))">Collect consent</b-nav-item>
                <b-nav-item href="/checkStatus" v-if="authenticated && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin') || hasRole('org-user'))">Check immunization status</b-nav-item>
                  <b-nav-item-dropdown id="respsafe-dropdown" text="RespSafe" v-if="authenticated && showRespSafe() && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin') || hasRole('org-user'))">
                    <b-dropdown-item href="/respSafeReg" v-if="authenticated && showRespSafe() && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin') || hasRole('org-user'))">RespSafe registration</b-dropdown-item>
                    <b-dropdown-item href="/respSafeReport" v-if="authenticated && showRespSafe() && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin') || hasRole('org-user'))">RespSafe report module</b-dropdown-item>
                    <b-dropdown-item href="/respSafeHistory" v-if="authenticated && showRespSafe() && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin'))">RespSafe report history</b-dropdown-item>
                  </b-nav-item-dropdown>
                  <b-nav-item-dropdown id="admin-dropdown" text="Admin" v-if="authenticated && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin'))">
                    <b-dropdown-item href="/userManagementSearch" v-if="authenticated && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin'))" text="User Management">User management</b-dropdown-item>
                    <b-dropdown-item href="/facilityManagement" v-if="authenticated && (hasRole('mdh-admin') || hasRole('mnit-admin') || hasRole('org-admin'))">Facility management</b-dropdown-item>
                    <b-dropdown-item href="/admin/approval" v-if="authenticated && (hasRole('mdh-admin') || hasRole('mnit-admin'))">View access requests</b-dropdown-item>
                  </b-nav-item-dropdown>
                  <b-nav-item @click="logout" v-if="authenticated">Log out</b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </div>
          <div v-if="!authenticated">
            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav align="center">
                <b-nav-item href="/">Home</b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </div>
        </b-navbar>
      </div>
    </header>

    <main id="main-content">
      <b-container fluid>
        <router-view/>
      </b-container>
    </main>

    <footer v-if="this.$route.name !== 'landing'">
      <div class="mt-5">
        <hr/>
        <div class="fluid-container footer justify-content-center">
          <p class="text-center" style="font-size:.85em;">
            <span>
              For questions email the VaxCheck Team at <a href="mailto:Health.VaxCheck@state.mn.us"><u>Health.VaxCheck@state.mn.us</u></a>
            </span><br/>
              <span>v{{appVersion}}</span>
          </p>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
import {version} from '../package.json';
import axios from "axios";

export default {
  data: () => ({
    orgType: '',
  }),
  computed: {
    authenticated: function() {
      if (this.$keycloak) {
        return this.$keycloak.authenticated;
      } else {
        return false;
      }
    },
    appVersion: function() {
      return version;
    }
  },
  mounted() {
    this.showRespSafe()
  },

  methods: {
    login () {
      this.$store.dispatch('resetState');
      this.$keycloak.clearToken();
      this.$keycloak.logoutFn();
    },
    logout() {
        this.$store.dispatch('resetState')
        this.$keycloak.clearToken()
        this.$keycloak.logoutFn()
    },
    hasRole(roles) {
      if (this.$keycloak.authenticated) {
        return this.$keycloak.hasResourceRole(roles);
      } else {
        return false;
      }
    },
    showRespSafe() { // only show RespSafe menu to hospitals or long-term care facilities
      if (this.$store.state.showRespSafe === false) {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/org`).then(response => {
          this.orgType = response.data.intendedUse
          if (this.orgType === 'Hospital' || this.orgType === 'Long-term care facility') {
            this.$store.commit("UPDATE_RESPSAFE_STATE", true)
            return true
          }
        })
      } else {
        return true
      }
    },
  }
}
</script>

<style lang="scss">

@import "assets/_custom.scss";
@import "vue-select/src/scss/vue-select.scss";
@import "~bootstrap/scss/bootstrap.scss";
@import '~bootstrap-vue/dist/bootstrap-vue.css';
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

#app {
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

h1, .h1 {
  font-size: 30px;
  font-weight: 600;
}

h2, .h2 {
  font-size: 24px;
  font-weight: 600;
}

h3, .h3 {
  font-size: 18px;
  font-weight: 600;
}

button {
  margin-right: 18px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.bg-mdh {
  background-color: rgb(0, 56, 101);
}

#nav {
  padding-bottom: 30px;
}

#nav a {
  font-weight: normal;
  color: white;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#nav a.dropdown-item {
  color: black !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

.colWidth40 {
  width: 40%;
}

.is-invalid .d-block {
    color: #ef0000;
}

.label-required::after {
  color: #c70000;
  font-size: .7em;
  text-transform: uppercase;
  margin-left: 19px;
  content:" required";
}

.wizard-card-footer div span {
  outline: none;
}

.wizard-card-footer div span:focus button {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
}

.wizard-nav li:has(.disabled) {
  user-focus: none;
 }

.card {
  margin-bottom: 2em;
}

.navbar-light .navbar-toggler-icon {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
}

.navbar-light .navbar-toggler {
  border-color: white;
}

.nav-heading {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.app-name {
  color: white;
}

.nav-item {
  margin-left: 0 !important;
  margin-right: 1em !important;
}

.nav-link {
  //padding-left: 0 !important;
  padding-right: 1em !important;
}

.sr-caption caption {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-caption caption:active,
.sr-caption caption:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}
</style>
